import styled from 'styled-components';

import { getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

import { sideSpacingOfHeaderFooter } from '../../OrderCart.styles';

export const ValuePromptList = styled.ul`
    ${sideSpacingOfHeaderFooter};
    margin-top: ${getPurpurSpacing('400')};
    margin-bottom: 0;
    list-style-type: none;
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('100')};
`;

export const ValuePromptListItem = styled.li`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    column-gap: ${getPurpurSpacing('150')};
    font-size: ${getPurpurTypography('scale100')};
    span {
        flex-shrink: 0;
    }
`;
